import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PTag, PTagProps } from '@porsche-design-system/components-react';

import { App } from '@/config/app';
import { useApplicationConfigs } from '@/hooks';

export const ApplicationTags = ({
  apps,
  variant,
}: {
  apps: string[];
  variant?: PTagProps['variant'];
}) => {
  const appConfigs = useApplicationConfigs();

  return (
    <ApplicationTagsContainer>
      {apps.map((app, index) => {
        const appConfig = appConfigs[app as App];

        return (
          <PTag key={`${app}-${index}`} variant={variant}>
            <a target="_blank" rel="noopener noreferrer" href={appConfig.href}>
              {appConfig.name}
            </a>
          </PTag>
        );
      })}
    </ApplicationTagsContainer>
  );
};

const ApplicationTagsContainer = styled('div', {
  base: {
    display: 'inline-grid',
    gap: 'sm',
    gridAutoFlow: 'column',
    gridAutoColumns: 'max-content',
  },
});
